import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { useSelector, useDispatch } from "react-redux";
import {
  sinhalaData,
  englishData,
  tamilData,
} from "../../../dummyData/PaymentSuccessPageData";
import { upgradeToPro } from "../../../redux/userSlice";
import { useLazyGetPaymentStatusQuery } from "../../../redux/service/paymntService";

function PaymentSuccessPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(sinhalaData[0]);
  const [triggerGetStatus] = useLazyGetPaymentStatusQuery();

  useEffect(() => {
    switch (selectedLanguage.value) {
      case "english":
        setLanguage(englishData[0]);
        break;
      case "tamil":
        setLanguage(tamilData[0]);
        break;
      default:
        setLanguage(sinhalaData[0]);
        break;
    }
  }, [selectedLanguage]);

  useEffect(() => {
    const navTimer = setTimeout(() => {
      navigate("/");
    }, 5000);

    return () => clearTimeout(navTimer);
  }, [navigate]);

  // PayHere's return_url can land here instead of /payhere/return depending on
  // backend config. This page previously never updated Redux, so isPro stayed
  // stale until the user logged out/in. Poll and flip it here too.
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const orderId =
      urlParams.get("order_id") ||
      localStorage.getItem("payhere_last_order_id");

    if (!orderId) return;

    let tries = 0;
    const maxTries = 12;
    const timer = setInterval(async () => {
      tries += 1;
      try {
        const json = await triggerGetStatus(orderId).unwrap();
        if (json?.success && json?.data?.isProUser === true) {
          clearInterval(timer);
          dispatch(upgradeToPro());
          localStorage.removeItem("payhere_last_order_id");
          return;
        }
      } catch (e) {
        // keep retrying until maxTries
      }
      if (tries >= maxTries) clearInterval(timer);
    }, 2000);

    return () => clearInterval(timer);
  }, [dispatch, triggerGetStatus]);



  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div
        className="card shadow-lg p-4 text-center"
        style={{ maxWidth: "450px" }}
      >
        {/* Success Icon */}
        <div className="mb-3">
          <div
            className="rounded-circle bg-success d-inline-flex align-items-center justify-content-center"
            style={{ width: "80px", height: "80px" }}
          >
            <i className="bi bi-check-lg text-white fs-1"></i>
          </div>
        </div>

        {/* Message */}
        <h3 className="text-success fw-bold">{language.Title}</h3>
        <p className="text-muted mt-2">{language.title1}</p>

        {/* Button */}
        <button
          className="btn btn-success mt-3 w-100"
          onClick={() => navigate("/")}
        >
          {language.btnText}
        </button>

        {/* Auto Redirect Text */}
        <small className="text-muted d-block mt-3">{language.title2}</small>
      </div>
    </div>
  );
}

export default PaymentSuccessPage;
